import { useMemo } from 'react';
import classNames from "classnames";
import { flatten } from 'underscore';

import { PropsWithClassName } from 'shared/props';
import { ContentPanel, EtfLabel } from 'shared/ui-kit';

import { FactorAnalsysisBackendUpDown } from "api/analysis";

import { createHelpHref } from '../utils';

import styles from "./top.module.scss";

export interface EtfFactorAnalysisTopProps {
	ticker: string;
	up: FactorAnalsysisBackendUpDown;
	down: FactorAnalsysisBackendUpDown
}
export const EtfFactorAnalysisTop = (props: EtfFactorAnalysisTopProps & PropsWithClassName) => {
	return (
		<ContentPanel title={<EtfLabel ticker={props.ticker} suffix="Основные факторы" />} className={props.className} help={{ href: createHelpHref("top") }}>
			<div className={classNames("flex-size-fill", "flex-container-horizontal", "flex-container-horizontal-break-1000", styles.container)}>
				<EtfFactorAnalysisUpDownCore className="flex-size-fill" ticker={props.ticker} direction="падает" upDown={props.down} />
				<EtfFactorAnalysisUpDownCore className="flex-size-fill" ticker={props.ticker} direction="растет" upDown={props.up} />
			</div>
		</ContentPanel>
	);
}

interface EtfFactorAnalysisTopCoreProps extends PropsWithClassName {
	ticker: string;
	direction: string;
	upDown: FactorAnalsysisBackendUpDown;
}
interface EtfFactorAnalysisTopItem {
	compareTicker: string;
	compareDescription: string;
	rate: number;
	direction: string;
	directionClass: string;
}
const EtfFactorAnalysisUpDownCore = (props: EtfFactorAnalysisTopCoreProps) => {
	const items = useMemo(() => {
		const calculation: EtfFactorAnalysisTopItem[][] = props.upDown.entries.map(entry => {
			var upRate = entry.upCounts / props.upDown.count - 0.3;
			var downRate = entry.downCounts / props.upDown.count - 0.3;

			if (upRate > 0 && downRate > 0) {
				return [
					{
						compareTicker: entry.compareTicker,
						compareDescription: entry.compareDescription,
						rate: (upRate + downRate) / 2,
						direction: 'волатилен',
						directionClass: styles.volatile
					}
				];
			}
			else {
				return [
					{
						compareTicker: entry.compareTicker,
						compareDescription: entry.compareDescription,
						rate: upRate,
						direction: 'растет',
						directionClass: styles.grow
					},
					{
						compareTicker: entry.compareTicker,
						compareDescription: entry.compareDescription,
						rate: downRate,
						direction: 'падает',
						directionClass: styles.drop
					}
				];
			}
		})

		var result = flatten(calculation)
			.filter(item => item.rate >= 0)
			.sort((first, second) => second.rate - first.rate)
			.slice(0, 3);
		return result;
	},
		[props.upDown]);

	return (
		<div className={classNames(props.className, styles.upDown)}>
			<p className={styles.title}>{props.ticker} {props.direction}…</p>
			{
				items.length === 0
					? (
						<p key="no-data" className={styles.item}>
							Нет факторов
						</p>
					)
					: (
						items.map(item => (
							<p key={item.compareTicker} className={styles.item}>
								Когда <span className={item.directionClass}>{item.direction}</span> <a href={`#${item.compareTicker}`}>{item.compareDescription}</a>
							</p>
					)
				
				))
			}
		</div>
	)
}
